
















































































































































































































































































import Vue from "vue";
import { Component, Prop, Watch } from "vue-property-decorator";
import Engine, { Building, Expansion, factionPlanet, Planet, Player } from "@gaia-project/engine";
import { factionColor } from "../graphics/utils";
import TechTile from "./TechTile.vue";
import Booster from "./Booster.vue";
import SpecialAction from "./SpecialAction.vue";
import FederationTile from "./FederationTile.vue";
import BuildingGroup from "./PlayerBoard/BuildingGroup.vue";
import PlayerBoardInfo from "./PlayerBoard/Info.vue";
import PowerBowls from "./PlayerBoard/PowerBowls.vue";
import Rules from "./Rules.vue";
import { factionData, factionName, planetsWithSteps } from "../data/factions";
import { MapMode, MapModeType } from "../data/actions";
import { mapModeTypeOptions } from "../data/stats";

@Component({
  components: {
    TechTile,
    Booster,
    SpecialAction,
    FederationTile,
    BuildingGroup,
    PowerBowls,
    PlayerBoardInfo,
    Rules,
  },
})
export default class PlayerInfo extends Vue {
  @Prop()
  player: Player;

  protected selectedMapModeType: MapModeType = MapModeType.default;

  get playerData() {
    return this.player?.data;
  }

  playerClick(player: Player) {
    this.$store.dispatch("playerClick", player);
  }

  get factionColor() {
    return factionColor(this.faction);
  }

  get name() {
    if (this.player.name) {
      return this.player.name;
    }
    return "Player " + (this.player.player + 1);
  }

  get gameData(): Engine {
    return this.engine;
  }

  get avatar(): string {
    return (
      this.$store.state.avatars[this.player.player] || `https://avatars.dicebear.com/api/pixel-art/${this.name}.svg`
    );
  }

  get planet() {
    return factionPlanet(this.faction);
  }

  get faction() {
    return this.player.faction;
  }

  get factionName(): string {
    return factionName(this.faction);
  }

  recentAction(i: number): boolean {
    const action = this.player.actions[i];
    const commands = this.$store.getters.recentActions.get(this.faction) ?? [];
    return commands.some((c) => c.args[0] === action.rewards);
  }

  planetFill(planet: string) {
    if (planet === Planet.Titanium || planet === Planet.Swamp) {
      return "white";
    }
    return "black";
  }

  planetsWithSteps(steps: number) {
    return planetsWithSteps(this.planet, steps);
  }

  get passed() {
    return (this.engine.passedPlayers || []).includes(this.player.player);
  }

  get round() {
    return this.engine.round;
  }

  get hasLostPlanet() {
    return (this.player.ownedPlanetsCount.l ?? 0) > 0;
  }

  get isFrontiers() {
    return this.engine.expansions == Expansion.Frontiers;
  }

  get engine() {
    return this.$store.state.data;
  }

  get height() {
    return this.isFrontiers ? "26.2" : "21.4";
  }

  get ships(): Building[] {
    return Building.ships();
  }

  get shipPositions() {
    return {
      [Building.ColonyShip]: "translate(0, 0)",
      [Building.ConstructionShip]: "translate(8.5, 0)",
      [Building.ResearchShip]: "translate(17, 0)",
      [Building.TradeShip]: "translate(25.5, 0)",
      [Building.Scout]: "translate(0, 3)",
      [Building.Frigate]: "translate(8.5, 3)",
      [Building.BattleShip]: "translate(17, 3)",
    };
  }

  togglePlanetHighlight(planet: Planet) {
    this.$store.commit("toggleMapMode", { type: "planetType", planet } as MapMode);
  }

  get selectedMapModes(): MapMode[] {
    return this.$store.getters.mapModes;
  }

  get mapModeType(): MapModeType {
    return this.selectedMapModes.find((m) => m.player == this.player.player)?.type ?? MapModeType.default;
  }

  get mapModeTypeOptions() {
    return mapModeTypeOptions;
  }

  toggleMapMode(mode: MapModeType) {
    this.$store.commit("toggleMapMode", { type: mode, player: this.player.player } as MapMode);
  }

  @Watch("selectedMapModes")
  resetMapMode() {
    this.selectedMapModeType = this.mapModeType;
  }

  get strategyLink() {
    return factionData[this.faction].strategyLink;
  }
}
